(() => {
    'use strict';

    const ALL = 'Show all';

    function programFinder(programService, $scope) {

        let programs;
        const resultsElm = document.getElementById('program-results');

        document.querySelector('[data-international]') || localStorage.getItem('view_pref') === 'int'
            ? this.internationalOnly = '1' : {};

        this.internationalOnly ? this.isInternational = '1' : {};
        this.noResults = false;

        $scope.$watch(() => this.isInternational, () => {
            localStorage.setItem('view_pref', (this.isInternational === '1' ? 'int' : 'dom'));
        });

        const hasValue = (program, key, value, substringMatch = false) => {
            if (!value || value === ALL)
                return true;

            const lowerVal = value.toLowerCase();
            return program[key] && program[key].some(x => substringMatch ? x.toLowerCase().includes(lowerVal) : x.toLowerCase() === lowerVal);
        };

        const findValueStartingWith = (arr, value) => arr.find(x => x.toLowerCase().startsWith(value.toLowerCase()));

        const scrollToResults = () => {
            if (!resultsElm) return;

            var headerOffset = 75;
            var elementPosition = resultsElm.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }

        this.clear = () => {
            resetFields();
            this.programs = [];
        }


        /**
         * 
         * @param {any} searchResults
         */
        this.filter = searchResults => {
            const filteredPrograms = [];
            
            (searchResults || programs).forEach(p => {
                // Check if the parent program matches the filters
                const parentMatches = p.studyLevel === this.programLevel &&
                    hasValue(p, 'studyArea', this.discipline) &&
                    hasValue(p, 'programType', this.programType) &&
                    hasValue(p, 'locations', this.studyLocation, true) &&
                    (this.isInternational === '1' ? p.cricosCode : !p.internationalOnly);

                if (parentMatches) {
                    filteredPrograms.push(p);
                }

                // Check program variants (inherit studyArea, programType, cricosCode from parent)
                if (p.variants && p.variants.length) {
                    p.variants.forEach(variant => {
                        const variantMatches = p.studyLevel === this.programLevel &&
                            hasValue(p, 'studyArea', this.discipline) &&           // inherited from parent
                            hasValue(p, 'programType', this.programType) &&         // inherited from parent
                            hasValue(variant, 'locations', this.studyLocation, true) && // use variant's own locations
                            (this.isInternational === '1' ? p.cricosCode : !p.internationalOnly); // inherited from parent

                        if (variantMatches) {
                            filteredPrograms.push({
                                ...variant,
                                studyLevel: p.studyLevel,
                                studyArea: p.studyArea,
                                programType: p.programType,
                                locations: variant.locations,
                                locationsString: variant.locations ? variant.locations.join(', ') : '',
                                cricosCode: p.cricosCode,
                                internationalOnly: p.internationalOnly
                            });
                        }
                    });
                }
            });

            this.programs = filteredPrograms.sort((a, b) => a.name.localeCompare(b.name));

            this.noResults = this.programs.length === 0;
            this.noResults ? {} : scrollToResults();
        }


        /**
         *
         * */
        this.search = () => {
            this.programs = [];

            this.filter();
        }


        /**
         * 
         * */
        programService.init(document.querySelector('[data-nodeid]').dataset.nodeid).then(resp => {

            programs = resp.programs;

            //this.preFilters = resp.preFilters;
            this.programs = resp.featuredPrograms;

            if (this.isInternational === undefined) {
                this.isInternational = '0'
            }

            this.disciplines = resp.filters.find(x => x.safe === 'study-area').options;
            this.studyLocations = resp.filters.find(x => x.safe === 'location').options;
            this.programLevels = resp.filters.find(x => x.safe === 'study-level').options;

            // program types must filter out types with no programs
            let programTypes = resp.filters.find(x => x.safe === 'program-type').options;
            programTypes = programTypes.filter(p => programs.some(x => x.programType && x.programType.includes(p)));

            let ug = [];
            let pg = [];

            programs.forEach(p => {
                // format career and locations to avoid rendering slowness
                p.careersString = p.careers ? p.careers.join(', ') : '';
                p.locationsString = p.locations ? p.locations.join(', ') : '';

                (p.studyLevel === 'Postgraduate' ? pg : ug).push(...p.programType);
            });

            this.programTypes = {
                ug: [...new Set(ug)],
                pg: [...new Set(pg)],
            };

            initFilterValues();

            // if a querystring exists, one of these will have a value,
            // so should submit the search on load
            if (this.studyLocation || this.discipline) {
                this.filter();
            }
        });


        /**
         * 
         * */
        const initFilterValues = () => {
            this.programLevel = 'Undergraduate';
            this.disciplines.unshift(ALL);
            this.studyLocations.unshift(ALL);

            this.programTypes.ugpg = [ALL, ...this.programTypes.ug, ...this.programTypes.pg];
            this.programTypes.ug.unshift(ALL);
            this.programTypes.pg.unshift(ALL);

            resetFields();
        }


        /**
         * 
         * */
        const resetFields = () => {
            let params = (new URL(document.location)).searchParams;
            let discipline = params.get('discipline');
            let location = params.get('location');

            if (location) {
                this.studyLocation = findValueStartingWith(this.studyLocations, location);
            }

            if (discipline) {
                this.discipline = findValueStartingWith(this.disciplines, discipline);
            }
        }
    }

    angular.module('Uscapp').controller('ProgramFinderCtrl', ['programService', '$scope', programFinder]);


    /**
     * A controller for managing visibility of list items in the static program list, when the frontend location filter is enabled
     * Also respects the view_pref property, to hide non-international programs when view_pref === 'int'
     * */
    function programFinder2() {

        const updateLiClass = (className, add) => {
            const noCricosPrograms = document.querySelectorAll('[data-international*="False"]');
            Array.from(noCricosPrograms).forEach(p => p.classList[add ? 'add' : 'remove'](className));
        }

        const containers = document.querySelectorAll('.program-list--container__inner');

        this.groups = {};
        this.hiddenGroups = {};
        this.viewPref = localStorage.getItem('view_pref');

        if (this.viewPref === 'int') {
            updateLiClass('d-none', true);
        }

        Array.from(containers).forEach(c => {
            this.groups[c.id] = Array.from(c.querySelectorAll('li'));
            this.hiddenGroups[c.id] = this.groups[c.id].length;
        });

        this.showAll = () => {
            this.viewPref = 'dom';
            localStorage.setItem('view_pref', this.viewPref);
            updateLiClass('d-none', false);
            this.update();
        }

        this.update = location => {
            this.location = location;

            Object.keys(this.groups).forEach(key => {
                this.groups[key].forEach(li => {
                    const isHiddenByIntPref = li.classList.contains('d-none');

                    if (!location || location === 'Any location') {
                        // Show all, unless hidden by international filter
                        li.classList.toggle('ng-hide', isHiddenByIntPref);
                    } else {
                        const matches = li.dataset.location.includes(location);
                        li.classList.toggle('ng-hide', !matches || isHiddenByIntPref);
                    }
                });

                // Update hiddenGroups state
                this.hiddenGroups[key] = this.groups[key].every(li =>
                    li.classList.contains('ng-hide') || li.classList.contains('d-none')
                );
            });
        };
    }

    angular.module('Uscapp').controller('ProgramFinder2Ctrl', [programFinder2]);

})();